/**
 * @generated SignedSource<<df955ba6b4a0f8d54b9f037c18e2158c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomerSchedule_Bookings$data = {
  readonly bookings: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly startSlot: {
          readonly agenda: {
            readonly date: string;
            readonly timeSlots: {
              readonly firstDateTime: string | null | undefined;
            } | null | undefined;
          };
          readonly dateTime?: string | null | undefined;
          readonly time?: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"BookingCard_Booking">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly club: {
    readonly departments: {
      readonly count: number;
    } | null | undefined;
  };
  readonly id: string;
  readonly managedBookings: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly startSlot: {
          readonly agenda: {
            readonly date: string;
            readonly timeSlots: {
              readonly firstDateTime: string | null | undefined;
            } | null | undefined;
          };
          readonly dateTime?: string | null | undefined;
          readonly time?: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"BookingCard_Booking">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "CustomerSchedule_Bookings";
};
export type CustomerSchedule_Bookings$key = {
  readonly " $data"?: CustomerSchedule_Bookings$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomerSchedule_Bookings">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "dateTimeGte",
    "variableName": "dateTimeGTE"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "DATE_TIME"
    }
  }
],
v3 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "startSlot",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Agenda",
                "kind": "LinkedField",
                "name": "agenda",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TimeSlotConnection",
                    "kind": "LinkedField",
                    "name": "timeSlots",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstDateTime",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dateTime",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "time",
                    "storageKey": null
                  }
                ],
                "type": "TimeSlot",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookingCard_Booking"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "dateTimeGTE"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomerSchedule_Bookings",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DepartmentConnection",
          "kind": "LinkedField",
          "name": "departments",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "bookings",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "BookingConnection",
      "kind": "LinkedField",
      "name": "managedBookings",
      "plural": false,
      "selections": (v3/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Customer",
  "abstractKey": null
};
})();

(node as any).hash = "fbce7c557d55438249b02795dfd0f8d5";

export default node;
